import React from "react";

import md5 from "md5";

import { Avatar, AvatarProps } from "@mui/material";

interface GravatarProps extends Omit<AvatarProps, "src"> {
  email: string | undefined | null;
  size?: number;
  defaultImage?: string;
  rating?: "g" | "pg" | "r" | "x";
}

const Gravatar: React.FC<GravatarProps> = ({
  email,
  size = 80,
  defaultImage = "retro",
  rating = "g",
  ...avatarProps
}) => {
  // Generate MD5 hash from email (trimmed and lowercased)
  const emailHash = email ? md5(email.trim().toLowerCase()) : "";

  // Construct Gravatar URL
  const gravatarUrl = `https://www.gravatar.com/avatar/${emailHash}?s=${size}&d=${defaultImage}&r=${rating}`;

  return (
    <Avatar
      src={gravatarUrl}
      alt={email || "User avatar"}
      sx={{
        width: size,
        height: size,
        ...avatarProps.sx,
      }}
      {...avatarProps}
    />
  );
};

export default Gravatar;
